import logo from "../images/logo.png";
import home from "../images/home.png";

import score from "../images/score.png";
import website from "../images/website.png";
import certificate from "../images/certificate.png";
import property from "../images/property.png";
import user from "../images/superhero.png";
import letter from "../images/love-letter.png";
import logout from "../images/exit.png";
import { useState, useEffect } from "react";
import "../styles/navbar.css"
import { FaUser } from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";
import api from "../pages/api"
import { MdLogout } from "react-icons/md";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [profile, setProfile] = useState(null);
    const [code, setCode] = useState(null);
    const navigate = useNavigate();

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);

        document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : 'auto';
    };
 useEffect(() => {
    api.get('student/api/v1/student-scores/me/').then((res) => {
        setProfile(res.data.my_score);  // ← اضافه کردن .my_score
    }).catch((err) => {
        console.error('خطا در گرفتن اطلاعات پروفایل:', err);
    })
}, [])


   

    const handleLogout = async () => {
        try {
            const refreshToken = localStorage.getItem("refreshToken");

            if (!refreshToken) {
                localStorage.clear();
                navigate("/login");
                window.location.reload(); // <-- force refresh
                return;
            }

            await api.post("manager/api/v1/logout", { refresh: refreshToken });

            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");

            navigate("/login");
            window.location.reload(); 
        } catch (error) {
            console.error("Logout failed:", error);
            localStorage.clear();
            navigate("/login");
            window.location.reload(); 
        }
    };


    return (<div className="mx-3 my-lg-4 my-0">

        <div className="header header-top-phone d-block d-lg-none">
            <div className="header-phone-inner">
                <div className="mobile-menu ">
                    <button
                        type="button"
                        className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
                        onClick={toggleMobileMenu}
                        aria-label="mobile-menu"
                    >
                        <span className="bars" >
                            <span className="bar " ></span>
                            <span className="bar"></span>
                            <span className="bar"></span>
                        </span>
                    </button>
                </div>
                <div className="mt-3" style={{ fontSize: "25px" }}>
                    <span >ythonteek</span><img src={logo} width={37} height={37} />
                </div>

                <Link className="mt-2" to="../about">
                    {profile?.profile_image ? (
                        <img
                            src={`${profile.profile_image}`}
                            alt={`${profile.full_name}`}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                objectFit: 'cover'
                            }}

                        />
                    ) : (
                        <FaUser style={{ fontSize: '40px', color: '#888' }} />
                    )}
                </Link>
            </div>
        </div>
        {/* Mobile Sidebar */}
        <div className={`mobile-sidebar ${isMobileMenuOpen ? 'active' : ''}`}>
            <div className="sidebar-content">

                <div className="branding ">
                    <a href="/" rel="home" className="link fs-1 fw-bold">
                        ythonteek

                        <img src={logo} width={35} height={35} />

                    </a>
                </div>

                <button
                    className="close-button "
                    onClick={toggleMobileMenu}
                    aria-label="Close menu"
                >
                    ×
                </button>




                <div className="sidebar-menu">
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                               <img src={property} width={38}  alt="Home" />
                            <span className="mx-2">خونه</span>
                        </NavLink>

                    </div>

                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/about"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                         <img src={user} width={34}  alt="user" />
                            <span className="mx-2">درباره من</span>
                        </NavLink>

                    </div>
                   
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/course"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                            <img src={website} width={30} />
                            <span className="mx-2">ویدیو های من  </span>
                        </NavLink>

                    </div>
                    
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/message"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                           <img src={letter} width={34}  alt="masseges" />

                            <span className="mx-2"> پیام های من  </span>
                        </NavLink>

                    </div>
                    <div style={{ position: "relative" }}>
                        <NavLink
                            to="/score"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                              <img src={certificate} width={30}  alt="certificate" />
                            <span className="mx-2">مدارک</span>
                        </NavLink>

                    </div>
                   
                    <div style={{ position: "relative" }} onClick={handleLogout}>
                        <NavLink
                            to="/login"
                            className={({ isActive }) =>
                                `sidebar-itemm my-5 d-block ${isActive ? "active" : ""}`
                            }
                        >
                             <img src={logout} width={34}  alt="logout" />
                            <span className="mx-2">   بیرون رفتن  </span>
                        </NavLink>

                    </div>


                </div>

            </div>
        </div>

    </div>);
}

export default Navbar;